export const scriptId = 'captcha-script';

export const aliyunCaptchaElementId = 'aliyun-captcha-element';
export const aliyunCaptchaButtonId = 'aliyun-captcha-button';
